import styled from 'styled-components';
import Colors from 'pubweb-smokey/dist/colors';

const BodyContentStyles = styled.div`
  p {
    margin-bottom: 40px;
    color: ${Colors.primary.black.standard};
  }

  a:link,
  a:visited,
  a:hover,
  a:active {
    color: ${Colors.primary.claytonBlue.standard};
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-bottom: 20px;
  }

  //contentful content
  .markdown {
    margin: auto;

    h2,
    h3,
    h4,
    h5,
    h6 {
      color: ${Colors.primary.black.standard};
      font-family: 'source-sans-pro', sans-serif;
    }
    h1 {
      font-weight: bold;
      font-size: 20px;
      line-height: 1.4;
      margin-bottom: 12px;
      width: 100%;
    }
    h2,
    h3 {
      font-weight: normal;
      font-size: 20px;
      line-height: 1.55;
      margin-bottom: 1px;
    }
    p {
      margin-bottom: 30px;
      word-wrap: break-word;
    }
    img {
      max-width: 100%;
    }

    a:link,
    a:visited,
    a:hover,
    a:active {
      color: ${Colors.primary.claytonBlue.standard};
      font-family: 'source-sans-pro', sans-serif;
    }

    ul,
    ol {
      color: ${Colors.primary.black.standard};
      color: green;

      li {
        color: ${Colors.primary.black.standard};
        font-family: 'source-sans-pro', sans-serif;
        line-height: 1.69;
        letter-spacing: -0.3px;
        position: relative;
        width: 100%;
      }
      margin-bottom: 20px;
    }
    ul {
      color: ${Colors.primary.black.standard};
      margin-left: 30px;
      list-style-type: none;

      li {
        &:before {
          color: ${Colors.primary.claytonBlue.standard};
          content: '\\2022';
          font-family: Arial, Helvetica, sans-serif;
          font-size: 19px;
          margin-right: 13px;
          margin-top: -2px;
        }
      }
    }
    ol {
      margin-left: 10px;
    }
  }
`;

export default BodyContentStyles;
